import './index.scss'
import {
  Modal,
  ComposedModal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  TextInput,
  Select,
  SelectItem,
  RadioButtonGroup,
  RadioButton
} from 'carbon-components-react'

Modal.Header = ModalHeader
Modal.Body = ModalBody
Modal.Footer = ModalFooter
Modal.Composed = ComposedModal
Modal.TextInput = TextInput
Modal.Select = Select
Modal.SelectItem = SelectItem
Modal.RadioButtonGroup = RadioButtonGroup
Modal.RadioButton = RadioButton
export {
  Modal,
  Select,
  SelectItem,
  RadioButtonGroup,
  RadioButton,
  Modal as default
}
